import { StatesModule, Transition } from '@uirouter/angular';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FranchiseIntranetUpgradeService } from '@fi-app/franchise-intranet-upgrade/franchise-intranet-upgrade.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiFranchiseIntranetUpgradeListComponent } from '@fi-app/franchise-intranet-upgrade/franchise-intranet-upgrade-list/franchise-intranet-upgrade-list.component';
import { Ng2StateDeclaration } from '@uirouter/angular';
import { FranchiseIntranetUpgradeModel } from '@fi-app/franchise-intranet-upgrade/franchise-intranet-upgrade.model';
import { FiFranchiseIntranetUpgradeEditComponent } from '@fi-app/franchise-intranet-upgrade/franchise-intranet-upgrade-edit/franchise-intranet-upgrade-edit.component';
import { FranchiseIntranetUpgradeViewComponent } from '@fi-app/franchise-intranet-upgrade/franchise-intranet-upgrade-view/franchise-intranet-upgrade-view.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export function CustomFranchiseIntranetUpgradeClass() {
    return 'view-with-inner-header';
}
const CustomFranchiseIntranetUpgradeState: Ng2StateDeclaration = {
    name: FiStateNames.Upgrade._name,
    url: '/Upgrade',
    abstract: true,
    component: FiAbstractStateComponent,
    resolve: {
        containerClass: [CustomFranchiseIntranetUpgradeClass],
    },
};

export function CustomFranchiseIntranetUpgradeListPageTitle(ccmPageTitle: PageTitleService) {
    return ccmPageTitle.setTitleForList(ObjectTypes.CustomFranchiseIntranetUpgrade);
}
export function CustomFranchiseIntranetUpgradeListUpcomingUpgradeStatus(
    FranchiseIntranetUpgradeService: FranchiseIntranetUpgradeService,
) {
    return FranchiseIntranetUpgradeService.GetUpcomingUpgradeStatus();
}
const CustomFranchiseIntranetUpgradeListState: Ng2StateDeclaration = {
    name: FiStateNames.Upgrade.List,
    url: '/?:sortColumn&:sortDirection&:offset',
    component: FiFranchiseIntranetUpgradeListComponent,
    reloadOnSearch: false,
    resolve: {
        pageTitle: [PageTitleService, CustomFranchiseIntranetUpgradeListPageTitle],
        upcomingUpgradeStatus: [
            FranchiseIntranetUpgradeService,
            CustomFranchiseIntranetUpgradeListUpcomingUpgradeStatus,
        ],
    },
};

export function AddCustomFranchiseIntranetUpgradeFranchiseIntranetUpgrade(
    FranchiseIntranetUpgradeService: FranchiseIntranetUpgradeService,
) {
    return FranchiseIntranetUpgradeService.GetFranchiseIntranetUpgrade(0);
}
export function AddCustomFranchiseIntranetUpgradePageTitle(
    ccmPageTitle: PageTitleService,
    FranchiseIntranetUpgrade: FranchiseIntranetUpgradeModel,
) {
    return ccmPageTitle.setTitle('Upgrade Edit - ' + FranchiseIntranetUpgrade.VersionNumberText);
}
export function AddCustomFranchiseIntranetUpgradeUpcomingUpgradeStatus(
    FranchiseIntranetUpgradeService: FranchiseIntranetUpgradeService,
) {
    return FranchiseIntranetUpgradeService.GetUpcomingUpgradeStatus();
}

const AddCustomFranchiseIntranetUpgradeState: Ng2StateDeclaration = {
    name: FiStateNames.Upgrade.Add,
    url: '/Add',
    component: FiFranchiseIntranetUpgradeEditComponent,
    resolve: {
        franchiseIntranetUpgrade: [
            FranchiseIntranetUpgradeService,
            AddCustomFranchiseIntranetUpgradeFranchiseIntranetUpgrade,
        ],
        pageTitle: [PageTitleService, 'franchiseIntranetUpgrade', AddCustomFranchiseIntranetUpgradePageTitle],
        upcomingUpgradeStatus: [
            FranchiseIntranetUpgradeService,
            AddCustomFranchiseIntranetUpgradeUpcomingUpgradeStatus,
        ],
    },
};

export function ModuleViewCustomFranchiseIntranetUpgradeFranchiseIntranetUpgrade(
    FranchiseIntranetUpgradeService: FranchiseIntranetUpgradeService,
    stateService: FiStateService,
    transition,
) {
    return FranchiseIntranetUpgradeService.GetFranchiseIntranetUpgrade(stateService.getParams(transition).Id);
}
export function ModuleViewCustomFranchiseIntranetUpgradePageTitle(
    ccmPageTitle: PageTitleService,
    FranchiseIntranetUpgrade: FranchiseIntranetUpgradeModel,
) {
    return ccmPageTitle.setTitle('Upgrade View - ' + FranchiseIntranetUpgrade.VersionNumberText);
}
const ModuleViewCustomFranchiseIntranetUpgradeState: Ng2StateDeclaration = {
    name: FiStateNames.Upgrade.View,
    url: '/:Id',
    component: FranchiseIntranetUpgradeViewComponent,
    resolve: {
        franchiseIntranetUpgrade: [
            FranchiseIntranetUpgradeService,
            FiStateService,
            Transition,
            ModuleViewCustomFranchiseIntranetUpgradeFranchiseIntranetUpgrade,
        ],
        pageTitle: [PageTitleService, 'franchiseIntranetUpgrade', ModuleViewCustomFranchiseIntranetUpgradePageTitle],
    },
};

export function ModuleEditCustomFranchiseIntranetUpgradeFranchiseIntranetUpgrade(
    FranchiseIntranetUpgradeService,
    stateService: FiStateService,
    transition: Transition,
) {
    return FranchiseIntranetUpgradeService.GetFranchiseIntranetUpgrade(stateService.getParams(transition).Id);
}
export function ModuleEditCustomFranchiseIntranetUpgradePageTitle(
    ccmPageTitle: PageTitleService,
    franchiseIntranetUpgrade: FranchiseIntranetUpgradeModel,
) {
    return ccmPageTitle.setTitle('Upgrade Edit - ' + franchiseIntranetUpgrade.VersionNumberText);
}
export function ModuleEditCustomFranchiseIntranetUpcomingUpgradeStatus(
    FranchiseIntranetUpgradeService: FranchiseIntranetUpgradeService,
) {
    return FranchiseIntranetUpgradeService.GetUpcomingUpgradeStatus();
}
const ModuleEditCustomFranchiseIntranetUpgradeState: Ng2StateDeclaration = {
    name: FiStateNames.Upgrade.Edit,
    url: '/:Id/Edit',
    component: FiFranchiseIntranetUpgradeEditComponent,
    resolve: {
        franchiseIntranetUpgrade: [
            FranchiseIntranetUpgradeService,
            FiStateService,
            Transition,
            ModuleEditCustomFranchiseIntranetUpgradeFranchiseIntranetUpgrade,
        ],
        pageTitle: [PageTitleService, 'franchiseIntranetUpgrade', ModuleEditCustomFranchiseIntranetUpgradePageTitle],
        upcomingUpgradeStatus: [
            FranchiseIntranetUpgradeService,
            ModuleEditCustomFranchiseIntranetUpcomingUpgradeStatus,
        ],
    },
};

export const FranchiseIntranetUpgradeStates: StatesModule = {
    states: [
        CustomFranchiseIntranetUpgradeState,
        CustomFranchiseIntranetUpgradeListState,
        AddCustomFranchiseIntranetUpgradeState,
        ModuleViewCustomFranchiseIntranetUpgradeState,
        ModuleEditCustomFranchiseIntranetUpgradeState,
    ],
};

export function registerUpgradeStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.Upgrade._name, FiStateNames.Upgrade.Edit], {
        SettingType: [ApplicationSettingsType.CustomFranchiseIntranetUpgrade],
        AccessType: AccessRightType.Admin,
    });
}
